module.exports = __webpack_public_path__ + "static/asana-1ea7cf8d9f48feaf80d536b1025cf6e0.png";